export const RXEXP_HEX_NUMBER = "[+-]?(0x[a-f0-9]+)";
export const RXEXP_NUMBER = "[+-]?(\\d{1,20}(?:\\.\\d{1,20})?(?:[Ee][+-]?\\d+)?)";
export const RXEXP_FLOATINGPOINT_NUMBER = "[+-]?(\\d{1,20}(?:\\.\\d{1,20})?(?:[Ee][+-]?\\d+)?)";
export const RXEXP_FLOATINGPOINT_NUMBER_TEXT = "[+-]?(\\d{1,}(?:\\.\\d{1,})?(?:[Ee][+-]?\\d+)?)";
export const RXEXP_FIXPOINT_NUMBER = "[+-]?\\d+(\\.\\d+)?";
export const RXEXP_INTEGER_NUMBER = "[+-]?(0|([1-9]\\d*))";
export const RXEXP_FUZZY_INTEGER_NUMBER = "[+-]?(\\d*)";
// A "fuzzy integer" is a text representation which can be parsed to an integer
// but is not written in the shortest possible way. The odd format can be meaningful for incrementing values in text.
// In addition to the usual integers it accepts non-standard text representations:
//   *  leading zeros are accepted. They do not mean octal representation!
//
export const rxFixPointNumber = RegExp("^" + RXEXP_FIXPOINT_NUMBER + "$");
export const rxFloatingPointNumber = RegExp("^" + RXEXP_FLOATINGPOINT_NUMBER + "$");
export const rxIntegerNumber = RegExp("^" + RXEXP_INTEGER_NUMBER + "$");

// ORACLE NUMBERS preserve the digits of a number precisely but have a limited range for the exponent.
export const OracleNumber = {
  MAX_VALUE: 9.9999e-125, // that is 1e+126 - epsilon
  MIN_VALUE: 1e-130,
  DENORMALIZED_MIN_VALUE: 1e-130,
};

// Mirror the limits of JavaScript, Java and Oracle types of binary Float (32bit)  IEEE754-1985
export const Float = {
  MAX_VALUE: 3.40282e38,
  MIN_VALUE: 1.17549e-38,
  DENORMALIZED_MIN_VALUE: 9e-44, // 1e-45 is not reproduced as 1e-45 but as 1.4e-45
};

// Mirror the limits of JavaScript, Java and Oracle types of binary Double (64bit)  IEEE754-1985
export const Double = {
  MAX_VALUE: 1.7976931348623157e308,
  MIN_VALUE: 2.2250738585072014e-308,
  DENORMALIZED_MIN_VALUE: 4.9e-324, // untested,  4.9e-324 is the official min, see Float.DENOMALIZED_MIN_VALUE
};

// Above numbers are exponents which can be safely converted in the GraphQL implementation
//  in the middle-tier.
//  GraphQL can convert "1e-128" to a Float value
//  but Java cannot convert oracles 3.5e+38 to a Float again.

//  Number(x) converts strings with larger negative exponents to 0
//  Math.log0(1e309) converts to Infinity and to 1e308 to 308

export interface ISplittedNumberText {
  mantissa?: string;
  exponent?: string;
}
